import { inject, Injectable } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { ActiveRepo, UniversalService } from '@commoncore/services/universal.service';

@Injectable({
  providedIn: 'root'
})

class SignInResolverService {
  
  constructor(private localStorageService : LocalStorageSvc,private router:Router,private universalService : UniversalService){

  }

  canResolve(route,state): Promise<boolean> | boolean {
    let userData = this.localStorageService.getUserData();
    if(userData){
      if(this.universalService.activeRepo == ActiveRepo.MAIN){
        this.router.navigate(['/home']);
      }else if(this.universalService.activeRepo == ActiveRepo.ENTERPRISE){
        this.router.navigate(['/dashboard']);
      }else{
        const sharekey = route.queryParams['u'];
        if(sharekey){
				  this.router.navigate(['/'], { queryParams: { u: sharekey } }); // redirect back to share page after login
        }else{
          window.location.href = "/";
        }
      }
      return false;
    }
    return true;
  }
}


export const signinResolver: ResolveFn<boolean> = (route, state) => {
  return inject(SignInResolverService).canResolve(route,state);
};